
export const SFS_DOMAIN = window.location.href.includes('localhost')
  ? 'http://alpha.solarforschools.co:8081'
  : 'https://www.solarforschools.co.uk'

export const getFileUrl = path => `${SFS_DOMAIN}/get-file?path=${path}`
